module.exports = __webpack_public_path__ + "img/58.c951fd62.png";